
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/suggested",
      function () {
        return require("private-next-pages/jobs/suggested/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/suggested"])
      });
    }
  